module.exports = __webpack_public_path__ + "92042e810bec83a6a12ef9ccb15ea2d0.svg";